import React, {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Input from "../../../../../../components/input";
import PicButton from "../../../../../../components/pic-button";
import Icon from "../../../../../../components/icon";
import {
	editCustomField as setEditCustomField,
	updateCustomField as setUpdateCustomField,
	submitCustomField as setSubmitCustomField,
	putCustomField, customFieldDeletionConfirmationPopup
} from '../../../../../../../actions/customFieldsActions';
import CustomFieldTypes from './components/custom-field-types';

function CustomField ({item}) {

    const customFieldRef = useRef(null);

	const editCustomField = useSelector((state) => state.customFieldsReducer.editCustomField);
	const updateCustomField = useSelector((state) => state.customFieldsReducer.updateCustomField);
	const submitCustomField = useSelector((state) => state.customFieldsReducer.submitCustomField);

	const dispatch = useDispatch();

	const handleUpdateCustomField = () => {
		dispatch(setSubmitCustomField(item.id));
		dispatch(putCustomField(item.id, customFieldRef.current.value, item.valueType))
	};

	const handleDeleteCustomField = () => {
		dispatch(customFieldDeletionConfirmationPopup(item.id));
	};

    return (
    	<>
	        <div className="custom-field">
	            {
		            editCustomField === item.id
	                    ?
	                    <Input
	                        type={"text"}
	                        defaultValue={item.label}
	                        onChange={() => dispatch(setUpdateCustomField(item.id))}
	                        ref={ customFieldRef }
	                    />
	                    :
	                    <span>{item.label}</span>
	            }
		        {
			        submitCustomField === item.id
				    ?
				        <div className="custom-field__actions">
					        <Icon animated={'pulse'}
					              name="spinner" className="mr-2"/>
				        </div>
				    :
				        <div className="custom-field__actions">
					        {
						        updateCustomField === item.id
						        && <PicButton onClick={ handleUpdateCustomField }>
							        <Icon name="check"/>
						        </PicButton>
					        }
					        {
						        editCustomField === item.id
							        ?
							        <PicButton onClick={() => dispatch(setEditCustomField(""))}>
								        <Icon name="times"/>
							        </PicButton>
							        :
							        <PicButton onClick={() => dispatch(setEditCustomField(item.id))}>
								        <Icon name="pencil"/>
							        </PicButton>
					        }
					        <PicButton onClick={ handleDeleteCustomField }>
						        <Icon name="trash"/>
					        </PicButton>
				        </div>
		        }
	        </div>
		    <CustomFieldTypes item={item} />
		</>
    )
}

export default CustomField;
